import { useCallback } from 'react';

// material-ui
import { Grid } from '@mui/material';

import { useOneChipInfoContext } from 'contexts/OneChipInfoContext';
import PlanFilters from 'modules/networksapps/PlanFilters';
import DataComponent from 'modules/networksapps/DataComponent';
import InfinityScrollWrapper from 'modules/modals/SelectPlan/components/InfinityScrollContainer';
import RequestBoundary from 'components/Error/RequestBoundary';

const SharedSelectPlan = ({ preselect, onPlanOpen, children, usePlanList, readOnly = () => ({}) }) => {
  const {
    readOnlyFilters,
    filters,
    selected,
    setFilter,
    setFilters,
    data,
    isLoading,
    isSuccess,
    isError,
    execute,
    isNewData,
    setIsNewData,
  } = usePlanList({ preselect, readOnly });

  const { info } = useOneChipInfoContext();
  const infoData = info.data;

  const handleOpenPlanDetailsModal = useCallback(
    (data) => {
      onPlanOpen({ ...data, eid: infoData?.esim?.eid, platformType: infoData?.esim?.platformType });
    },
    [infoData]
  );

  const handleFetchMore = useCallback(() => {
    setIsNewData(false);
    setFilters((prev) => ({ ...prev, offset: prev.offset + prev.limit }));
  }, []);

  return (
    <>
      <PlanFilters
        readOnly={readOnlyFilters}
        isModal={true}
        selected={selected}
        filters={filters}
        onChange={setFilter}
      />
      <RequestBoundary isLoading={isLoading} isError={isError} onRetry={execute} isEmpty={data?.total === 0}>
        <InfinityScrollWrapper
          data={data}
          isLoading={isLoading}
          onFetchMore={handleFetchMore}
          isNew={isNewData}
          isSuccess={isSuccess}
        >
          {(state) => (
            <Grid container columnSpacing={2} alignItems={'right'} rowSpacing={{ xs: 2 }} sx={{ pt: 0, mt: 0 }}>
              {state.items.map((plan, index) => (
                <Grid item xs={6} key={`grid-${plan._id}`}>
                  <DataComponent
                    key={`tile-${plan._id}`}
                    isRecommendation={false}
                    item={plan}
                    onClick={() => handleOpenPlanDetailsModal(plan)}
                  >
                    {children ? children(plan) : null}
                  </DataComponent>
                </Grid>
              ))}
            </Grid>
          )}
        </InfinityScrollWrapper>
      </RequestBoundary>
    </>
  );
};

export default SharedSelectPlan;
